const upsellProduct = {
  id: 39893736325233,
}

document.addEventListener("DOMContentLoaded", function () {

  const buttonAddUpsell = document.querySelector(".button-upsell-and-price");
  const buttonBigSizeUpsell = document.querySelector(".product-specific-big-size-upsell");
  const buttonSmallSizeUpsell = document.querySelector(".product-specific-small-size-upsell");
  const buttonBigSizeUpsell30ML = document.querySelector(".text-product-specific-small-size-upsell-30ml");
  const buttonSmallSizeUpsell10ML = document.querySelector(".text-product-specific-small-size-upsell-10ml");
  const originalPrice = document.querySelector(".original-price");
  const discountPrice = document.querySelector(".discount-price");
  const imageUpsell = document.querySelector(".product-image-upsell");

  buttonBigSizeUpsell.style.paddingTop = '1px';
  buttonBigSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';
  
  buttonBigSizeUpsell.addEventListener('click', () => {

    buttonBigSizeUpsell.style.paddingTop = '1px';
    buttonBigSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';

    buttonSmallSizeUpsell.style.paddingTop = '';
    buttonSmallSizeUpsell.style.borderBottom = '';

    buttonBigSizeUpsell30ML.style.fontWeight = "600";
    buttonSmallSizeUpsell10ML.style.fontWeight = "400";

    upsellProduct.id = 39893736325233;

    const priceValue = buttonBigSizeUpsell.getAttribute('data-price');
    const discountValue = buttonBigSizeUpsell.getAttribute('data-discount-price');
    const imageVariant = buttonBigSizeUpsell.getAttribute('data-image');

    originalPrice.textContent = priceValue;
    discountPrice.textContent = discountValue;
    imageUpsell.src = imageVariant;

    buttonAddUpsell.classList.add('button-upsell-and-price-30ML');
    buttonAddUpsell.classList.remove('button-upsell-and-price-10ML');
  });  
  
  buttonSmallSizeUpsell.addEventListener('click', () => {
    
    buttonSmallSizeUpsell.style.paddingTop = '1px';
    buttonSmallSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';

    buttonBigSizeUpsell.style.paddingTop = '';
    buttonBigSizeUpsell.style.borderBottom = '';

    buttonBigSizeUpsell30ML.style.fontWeight = "400";
    buttonSmallSizeUpsell10ML.style.fontWeight = "600";

    upsellProduct.id = 39893736358001;

    const priceValue = buttonSmallSizeUpsell.getAttribute('data-price');
    const discountValue = buttonSmallSizeUpsell.getAttribute('data-discount-price');
    const imageVariant = buttonSmallSizeUpsell.getAttribute('data-image');

    originalPrice.textContent = priceValue;
    discountPrice.textContent = discountValue;
    imageUpsell.src = imageVariant;

    buttonAddUpsell.classList.remove('button-upsell-and-price-30ML');
    buttonAddUpsell.classList.add('button-upsell-and-price-10ML');
  });
  
  // buttonAddUpsell.addEventListener('click', () => {      
  //   addElementCart(upsellProduct.id)
  // });
});

// async function addElementCart(variantId){

//   let formData = {
//     items: [
//       {
//         id: variantId,
//         quantity: 1 
//       }
//     ]
//   }; 

//   await fetch("/cart/add.js", {
//       method: "post",
//       headers: {
//           'Content-Type': 'application/json'
//         },
//       body: JSON.stringify(formData),
//   })
//   .then(response => {
//     return response.json();
//   })
//   .then(data => {
//     console.log('Product added to cart:', data);
//     console.log("Aqui cart oppen...")
//     cartOpen();
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   })
// }

